import { useBundle } from '@amzn/react-arb-tools';
import { Col } from '@amzn/stencil-react-components/layout';
import { Text, TextVariant } from '@amzn/stencil-react-components/text';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { trackClick } from 'src/analytics/clickTracking';
import { recordRumEvent } from 'src/analytics/rum';
import { NOT_FOUND_MESSAGE_BUNDLE_NAME } from 'src/constants';
import {
  NOT_FOUND_PAGE_GROUP,
  PAGE_LOAD_EVENT,
} from 'src/constants/MonitoringConstants';
import { t } from '../helpers';
import pageNotFoundImage from '../images/404.svg';
import { PREFERS_COLOR_SCHEME_ID } from '@amzn/stencil-design-tokens/js/web/utils';
import { ThemeMode } from '@amzn/stencil-react-components/context';
import { Button, ButtonVariant } from '@amzn/stencil-react-components/button';

const PageNotFound = () => {
  const [bundle] = useBundle(NOT_FOUND_MESSAGE_BUNDLE_NAME);
  const navigate = useNavigate();

  useEffect(() => {
    recordRumEvent(PAGE_LOAD_EVENT, { pageGroup: NOT_FOUND_PAGE_GROUP });
  }, []);

  return (
    <Col
      dataTestId="grow-thrive-connect-not-found-test-id"
      alignItems="center"
      gridGap="dimensions.spacing.300"
      padding="dimensions.spacing.700"
      {...{ [PREFERS_COLOR_SCHEME_ID]: ThemeMode.Dark }}
    >
      <img src={pageNotFoundImage} alt="" aria-hidden="true" loading="lazy" />
      <Text variant={TextVariant.HeadingMD} color="color.text.primary">{t(bundle, 'page_not_found')}</Text>
      <Button
        dataTestId="page-not-found-redirect-home-button-data-test-id"
        variant={ButtonVariant.Primary}
        role="link"
        onClick={() => {
          trackClick({
            elementId: 'back-to-homepage',
            elementType: 'button',
            pageGroup: NOT_FOUND_PAGE_GROUP,
          });
          navigate('/');
        }}
      >
        <Text color="color.text.primary">
          {t(bundle, 'back_to_homepage')}
        </Text>
      </Button>
    </Col>
  );
};

export default PageNotFound;
